// Enregistrement du service worker et detection des mises a jour.
//
// Le service worker vit dans public/service-worker.js : il doit etre servi
// depuis la racine pour avoir une portee sur toute l'application.

const estLocalhost = Boolean(
  window.location.hostname === 'localhost'
  || window.location.hostname === '[::1]'
  || window.location.hostname.match(/^127(\.\d{1,3}){3}$/),
);

export function register(callbacks = {}) {
  if (!('serviceWorker' in navigator)) return;
  // En developpement CRA sert les fichiers depuis la memoire : un service
  // worker y masquerait le rechargement a chaud.
  if (process.env.NODE_ENV !== 'production' && !estLocalhost) return;
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    const url = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker.register(url)
      .then((enregistrement) => {
        enregistrement.onupdatefound = () => {
          const entrant = enregistrement.installing;
          if (!entrant) return;
          entrant.onstatechange = () => {
            if (entrant.state !== 'installed') return;
            if (navigator.serviceWorker.controller) {
              // Une version precedente sert deja la page : celle-ci attend
              callbacks.onUpdate?.(enregistrement);
            } else {
              callbacks.onSuccess?.(enregistrement);
            }
          };
        };
      })
      .catch(() => { /* l'absence de service worker ne doit rien casser */ });
  });
}

// Active la version en attente puis recharge. Le rechargement est declenche par
// controllerchange, pas immediatement : sans cela la page repartirait sur
// l'ancienne version encore active.
export function appliquerMiseAJour(enregistrement) {
  const enAttente = enregistrement && enregistrement.waiting;
  if (!enAttente) { window.location.reload(); return; }
  let recharge = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recharge) return;
    recharge = true;
    window.location.reload();
  });
  enAttente.postMessage({ type: 'SKIP_WAITING' });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((e) => e.unregister())
    .catch(() => {});
}
